var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b23a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79266a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_51422",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#79266a",
    floodOpacity: 0.141,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36759",
    "data-name": "Group 36759",
    transform: "translate(10559 -21290)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36745",
    "data-name": "Group 36745",
    transform: "translate(-10540.031 21308.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57691",
    "data-name": "Path 57691",
    d: "M17.706,30.436a.022.022,0,0,0-.012.006,1.635,1.635,0,0,1-1.283-.086.545.545,0,0,1-.1.012H11.458a.617.617,0,0,1,0-1.234h4.015a1.651,1.651,0,0,1,.062-.863c.02-.056.967-2.812,1.347-3.922a2.036,2.036,0,0,1,.488-.78l1.057-1.057H11.458a.617.617,0,0,1,0-1.234h8.2l5.008-5.008V2.906A2.436,2.436,0,0,0,22.232.47H.031A4.268,4.268,0,0,1,1.326,3.226l.018.018V33.994a1.474,1.474,0,0,0,1.474,1.474H23.194a1.474,1.474,0,0,0,1.474-1.474V26.347l-2.26,2.26a2.032,2.032,0,0,1-.78.487l-3.922,1.342ZM11.458,5.57h9.689a.617.617,0,0,1,0,1.234H11.458a.617.617,0,1,1,0-1.233Zm0,7.857h9.689a.617.617,0,0,1,0,1.234H11.458a.617.617,0,1,1,0-1.233ZM9.238,31.793a.628.628,0,0,1-.629.629H4.927a.628.628,0,0,1-.629-.629V27.71a.628.628,0,0,1,.629-.629H8.609a.628.628,0,0,1,.629.629Zm0-7.857a.629.629,0,0,1-.629.635H4.927a.629.629,0,0,1-.629-.635V19.86a.629.629,0,0,1,.629-.635H8.609a.629.629,0,0,1,.629.635Zm0-7.851a.628.628,0,0,1-.629.629H4.927a.628.628,0,0,1-.629-.629V12a.624.624,0,0,1,.629-.629H8.609A.624.624,0,0,1,9.238,12Zm0-7.857a.628.628,0,0,1-.629.629H4.927A.628.628,0,0,1,4.3,8.229V4.146a.628.628,0,0,1,.629-.629H8.609a.628.628,0,0,1,.629.629Z",
    transform: "translate(0 0)",
    fill: "#869b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57692",
    "data-name": "Path 57692",
    d: "M336.668,268.784l8.611-8.611,3.295,3.295-8.611,8.611Z",
    transform: "translate(-317.687 -245.084)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57693",
    "data-name": "Path 57693",
    d: "M510.434,205.4l-1.79-1.79a1.064,1.064,0,0,0-1.5,0l-2.018,2.018,3.3,3.3,2.018-2.018A1.065,1.065,0,0,0,510.434,205.4Z",
    transform: "translate(-476.658 -191.411)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57694",
    "data-name": "Path 57694",
    d: "M296.405,433.27l4.1-1.405-3.3-3.3-1.405,4.1A.474.474,0,0,0,296.405,433.27Z",
    transform: "translate(-279.098 -404.001)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57695",
    "data-name": "Path 57695",
    d: "M23.363,33.8v.309a1.474,1.474,0,0,0,1.474,1.474H45.213a1.474,1.474,0,0,0,1.474-1.474V26.464l-2.26,2.26a2.031,2.031,0,0,1-.78.487l-3.922,1.342h0a.021.021,0,0,0-.012.006,1.635,1.635,0,0,1-1.283-.086.544.544,0,0,1-.1.012H33.477a.617.617,0,0,1,0-1.234h4.015a1.651,1.651,0,0,1,.062-.863c.02-.056.967-2.812,1.347-3.922a2.037,2.037,0,0,1,.488-.78l1.057-1.057H35.8a46.466,46.466,0,0,1-4.571,5.025.632.632,0,0,1,.024.175V31.91a.628.628,0,0,1-.629.629H26.946a.628.628,0,0,1-.629-.629v-.142Q24.909,32.806,23.363,33.8ZM36.735,21.394h4.945l5.008-5.008V3.023A2.436,2.436,0,0,0,44.437.594a33.9,33.9,0,0,1-.727,5.42.615.615,0,0,1-.178.785,39.413,39.413,0,0,1-2.272,6.744h1.906a.617.617,0,0,1,0,1.234H40.693A42.453,42.453,0,0,1,36.735,21.394Z",
    transform: "translate(-22.019 -0.117)",
    fill: "#c7e64b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57696",
    "data-name": "Path 57696",
    d: "M39.671,21.277H33.477a.617.617,0,0,0,0,1.234h5.282a55.885,55.885,0,0,1-7.5,8.071V27.71a.628.628,0,0,0-.629-.629H26.946a.628.628,0,0,0-.629.629v4.083a.628.628,0,0,0,.629.629h2.108a48.928,48.928,0,0,1-4.294,3.044,1.474,1.474,0,0,1-1.4-1.472V23.624q1.565-1.221,2.953-2.487v2.8a.629.629,0,0,0,.629.635h3.682a.629.629,0,0,0,.629-.635V19.86a.629.629,0,0,0-.629-.635H28.3q1.219-1.243,2.289-2.51h.035a.628.628,0,0,0,.629-.629v-.173A42.717,42.717,0,0,0,36.915,6.8h6.25a.617.617,0,0,0,0-1.234H37.454A39.5,39.5,0,0,0,39.188.47h5.063a2.436,2.436,0,0,1,2.436,2.436V8.014A55.127,55.127,0,0,1,39.671,21.277Zm3.495-7.85H33.477a.617.617,0,1,0,0,1.233h9.689a.617.617,0,0,0,0-1.234Z",
    transform: "translate(-22.019 0)",
    fill: "#abc73e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36746",
    "data-name": "Group 36746",
    transform: "translate(-10640 20779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36661",
    "data-name": "Group 36661",
    transform: "translate(80.732 510.732)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.27, 0.27)",
    filter: "url(#Path_51422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_51422-2",
    "data-name": "Path 51422",
    transform: "translate(0 0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 1 C 31.27458953857422 1 26.69105911254883 1.925247192382812 22.37673187255859 3.75006103515625 C 18.20906829833984 5.512832641601562 14.46591949462891 8.036598205566406 11.25125885009766 11.25125885009766 C 8.036598205566406 14.46591949462891 5.512832641601562 18.20906829833984 3.75006103515625 22.37673187255859 C 1.925247192382812 26.69105911254883 1 31.27458953857422 1 36 C 1 40.72541046142578 1.925247192382812 45.30894088745117 3.75006103515625 49.62326812744141 C 5.512832641601562 53.79093170166016 8.036598205566406 57.53408050537109 11.25125885009766 60.74874114990234 C 14.46591949462891 63.96340179443359 18.20906829833984 66.48716735839844 22.37673187255859 68.24993896484375 C 26.69105911254883 70.07475280761719 31.27458953857422 71 36 71 C 40.72541046142578 71 45.30894088745117 70.07475280761719 49.62326812744141 68.24993896484375 C 53.79093170166016 66.48716735839844 57.53408050537109 63.96340179443359 60.74874114990234 60.74874114990234 C 63.96340179443359 57.53408050537109 66.48716735839844 53.79093170166016 68.24993896484375 49.62326812744141 C 70.07475280761719 45.30894088745117 71 40.72541046142578 71 36 C 71 31.27458953857422 70.07475280761719 26.69105911254883 68.24993896484375 22.37673187255859 C 66.48716735839844 18.20906829833984 63.96340179443359 14.46591949462891 60.74874114990234 11.25125885009766 C 57.53408050537109 8.036598205566406 53.79093170166016 5.512832641601562 49.62326812744141 3.75006103515625 C 45.30894088745117 1.925247192382812 40.72541046142578 1 36 1 M 36 0 C 55.88224792480469 0 72 16.11774826049805 72 36 C 72 55.88224792480469 55.88224792480469 72 36 72 C 16.11774826049805 72 0 55.88224792480469 0 36 C 0 16.11774826049805 16.11774826049805 0 36 0 Z",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_51422-3",
    "data-name": "Path 51422",
    transform: "translate(0.268 0.268)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 1 C 31.27458953857422 1 26.69105911254883 1.925247192382812 22.37673187255859 3.75006103515625 C 18.20906829833984 5.512832641601562 14.46591949462891 8.036598205566406 11.25125885009766 11.25125885009766 C 8.036598205566406 14.46591949462891 5.512832641601562 18.20906829833984 3.75006103515625 22.37673187255859 C 1.925247192382812 26.69105911254883 1 31.27458953857422 1 36 C 1 40.72541046142578 1.925247192382812 45.30894088745117 3.75006103515625 49.62326812744141 C 5.512832641601562 53.79093170166016 8.036598205566406 57.53408050537109 11.25125885009766 60.74874114990234 C 14.46591949462891 63.96340179443359 18.20906829833984 66.48716735839844 22.37673187255859 68.24993896484375 C 26.69105911254883 70.07475280761719 31.27458953857422 71 36 71 C 40.72541046142578 71 45.30894088745117 70.07475280761719 49.62326812744141 68.24993896484375 C 53.79093170166016 66.48716735839844 57.53408050537109 63.96340179443359 60.74874114990234 60.74874114990234 C 63.96340179443359 57.53408050537109 66.48716735839844 53.79093170166016 68.24993896484375 49.62326812744141 C 70.07475280761719 45.30894088745117 71 40.72541046142578 71 36 C 71 31.27458953857422 70.07475280761719 26.69105911254883 68.24993896484375 22.37673187255859 C 66.48716735839844 18.20906829833984 63.96340179443359 14.46591949462891 60.74874114990234 11.25125885009766 C 57.53408050537109 8.036598205566406 53.79093170166016 5.512832641601562 49.62326812744141 3.75006103515625 C 45.30894088745117 1.925247192382812 40.72541046142578 1 36 1 M 36 0 C 55.88224792480469 0 72 16.11774826049805 72 36 C 72 55.88224792480469 55.88224792480469 72 36 72 C 16.11774826049805 72 0 55.88224792480469 0 36 C 0 16.11774826049805 16.11774826049805 0 36 0 Z",
    stroke: "none",
    fill: "#adc927"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoicon);
export default __webpack_public_path__ + "static/media/Todoicon.365e9d6621985b00ad4c403014c73da1.svg";
export { ForwardRef as ReactComponent };